import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

export interface EmptyStateProps {
  icon?: IconName;
  title: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
}

/** Empty list state. Carries the next action or an explanation, never a bare blank. */
export function EmptyState({ icon = 'leaf-outline', title, children, action }: EmptyStateProps) {
  return (
    <div className="fw-empty">
      <Icon name={icon} size={40} color="var(--color-brand)" />
      <span className="fw-empty__title">{title}</span>
      {children && <span className="fw-empty__body">{children}</span>}
      {action && <div className="fw-empty__action">{action}</div>}
    </div>
  );
}
